<template>
  <div>
    <a-table style="clear: right" :pagination="pagination" :columns="columns" :loading="loading" size="middle" :data-source="sourceData" row-key="id" @change="handleTableChange">
      <span slot="issueTitle" slot-scope="text, record">
        <issue-title-edit :source-id="record.id" :title="record.title" :project_id="record.project_id" />
      </span>
      <span slot="tag" slot-scope="text, record">
        <a-popover placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
          </template>
          <template slot="title">
            <span>缺陷标签</span>
          </template>
          <a-tag v-for="(tag, index) in record.tags" :key="index" color="blue">{{ tag.name }}</a-tag>
        </a-popover>
      </span>
      <span slot="status" slot-scope="text, record">
        <issue-status-edit :issue-id="record.id" :status="record.status" :project_id="record.project_id" />
      </span>
      <span slot="serious" slot-scope="text, record">
        <issue-serious-edit :source-id="record.id" :source-value="record.serious" :project_id="record.project_id" />
      </span>
      <span slot="handler" slot-scope="text, record">
        <issue-user-edit :source-id="record.id" :source-value="record.handler" item="handler" :project_id="record.project_id" />
      </span>
      <span slot="creator" slot-scope="text, record">{{ getUser(record.creator) }}</span>
    </a-table>
    <issue-edit-modal ref="editModalRef" />
  </div>
</template>
<script>
import IssueUserEdit from '@/pages/project/issue/components/IssueUserEdit';
import IssueTitleEdit from '@/pages/project/issue/components/IssueTitleEdit';
import IssueEditModal from '@/pages/project/issue/components/IssueEditModal';
import IssueStatusEdit from '@/pages/project/issue/components/IssueStatusEdit';
import IssueSeriousEdit from '@/pages/project/issue/components/IssueSeriousEdit';
const columns = [
  {
    title: 'id',
    dataIndex: 'key',
    key: 'key',
    width: 110,
    fixed: 'left',
    ellipsis: true
  },
  {
    title: '缺陷标题',
    width: 500,
    ellipsis: true,
    fixed: 'left',
    scopedSlots: { customRender: 'issueTitle' }
  },
  {
    title: '状态',
    width: 100,
    fixed: 'left',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '缺陷等级',
    width: 100,
    scopedSlots: { customRender: 'serious' }
  },
  {
    title: '处理人',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'handler' }
  }
];

export default {
  components: { IssueEditModal, IssueUserEdit, IssueTitleEdit, IssueStatusEdit, IssueSeriousEdit },
  props: {
    sourceData: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      columns,
      tableData: [],
      loading: false,
      filterForm: {},
      pagination: {
        size: 'small',
        total: 0,
        current: 1,
        pageSize: 20, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '15', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      modalVisible: false
    };
  },
  computed: {
    getUser() {
      return user => {
        return user === null ? '--' : user.nickname;
      };
    }
  },
  methods: {
    handleTableChange(pagination) {
      this.pagination = pagination;
    },

    onAdd() {
      this.$refs.editModalRef.onOpen({});
    }
  }
};
</script>
<style lang="less" scoped>
.handle-menu {
  float: right;
  margin-bottom: 8px;
}
</style>
